module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/banner/vi-b4dfd6364ab7e308e1d9a147bf36d6c1.jpg";